<template>
  <div class="auth-form">
    <q-form @submit="handleRegister" class="q-gutter-md">
      <q-input
        v-model="userData.name"
        label="Nombre Completo"
        outlined
        dense
        required
      />
      <q-input
        v-model="userData.email"
        label="Email"
        type="email"
        outlined
        dense
        required
      />
      <q-input
        v-model="userData.password"
        label="Contraseña"
        type="password"
        outlined
        dense
        required
      />
      <div class="row justify-end q-mt-md">
        <q-btn 
          type="submit" 
          color="primary" 
          label="Registrarse" 
          :loading="authStore.loading"
          unelevated
        />
      </div>
      <div v-if="authStore.error" class="text-negative text-caption q-mt-sm">
        {{ authStore.error }}
      </div>
    </q-form>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { useAuthStore } from '/src/stores/useAuthStore.js';

const authStore = useAuthStore();
const userData = reactive({
  name: '',
  email: '',
  password: ''
});

const emit = defineEmits(['success']);

async function handleRegister() {
  const success = await authStore.register(userData);
  if (success) {
    emit('success');
  }
}
</script>

<style scoped>
.auth-form {
  padding: 16px;
}
</style>
